type AuthErrorListener = () => void;

const listeners = new Set<AuthErrorListener>();

export const authEvents = {
  onSessionExpired(listener: AuthErrorListener): () => void {
    listeners.add(listener);
    return () => {
      listeners.delete(listener);
    };
  },

  emitSessionExpired(): void {
    listeners.forEach((listener) => listener());
  },
};
